// extracted by mini-css-extract-plugin
module.exports = {"root":"_9YnJ_","example":"_1Fodi","add":"_2mcRH","empty":"_1TeFr"};